import { ghostBtnClass, mfgConfirmDialogClass, mfgPrimaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
// Modal that confirms the Template button before triggering the CSV
// download per the Inventory+Receive merge spec ("Download Inventory
// Template CSV?" pop-up). Inlined backdrop + dialog rather than a
// generic confirm primitive — there's no other consumer in the repo
// today, and the manufacturing surface gets enough modal-shape work
// (ManufacturingPanelModal / ManufacturingBulkImportModal) that a
// reusable primitive's seam can wait for the third caller.
type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ManufacturingInventoryTemplateConfirm({ open, onCancel, onConfirm }: Props) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="template-confirm-title"
      onClick={onCancel}
    >
      <div
        className={`max-w-sm ${mfgConfirmDialogClass}`}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="template-confirm-title" className="text-base font-semibold text-gray-900 dark:text-zinc-100">
          Download Inventory Template CSV?
        </h3>
        <p className="text-sm text-gray-600 dark:text-zinc-400">
          You&rsquo;ll get a CSV with sample rows showing the column shape Bulk import expects.
          Fill it in and re-upload through Bulk import.
        </p>
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" className={ghostBtnClass} onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className={mfgPrimaryBtnClass} onClick={onConfirm} autoFocus>
            Download
          </button>
        </div>
      </div>
    </div>
  );
}
